export const labels = {
    TRANSCRIBE: 'Transkribieren',
    VERIFY: 'Prüfen',
    READ: 'Lesen',
    UNPROCESSED: 'Unbearbeitet',
    PROCESSED: 'In Bearbeitung',
    GERMAN: 'Deutsch',
    CZECH: 'Tschechisch',
    ENGLISH: 'Englisch',
    FRENCH: 'Französisch',
    SLOVAK: 'Slowakisch',
    HUNGARIAN: 'Ungarisch',
    CROATIAN: 'Kroatisch',
    SLOVENIAN: 'Slowenisch',
    DUTCH: 'Niederländisch',
    POLISH: 'Polnisch',
    BULGARIAN: 'Bulgarisch',
    DESCRIPTIVE: 'Beschreibender Titel',
    ORIGINAL: 'Original Titel',
    from: 'Von (Ort)',
    to: 'Nach (Ort)',
    address: 'Volle Adresse',
    transcription: 'Mitteilung',
    translation: 'Übersetzung',
};
